var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.4 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #cbcb2c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st0",
    d: "M0,0h91.2v70.2c0,25.8-5.4,46.2-16.1,61.2-10.8,14.9-29.2,28.1-55.3,39.6L0,133.7c16.1-7.5,27.2-15.1,33.3-22.5,6.2-7.5,9.6-16.3,10.3-26.5H0V0ZM106.2,0h91.2v70.2c0,25.8-5.4,46.2-16.1,61.2-10.8,14.9-29.2,28.1-55.3,39.6l-19.7-37.3c16.1-7.5,27.2-15.1,33.3-22.5,6.2-7.5,9.5-16.3,10.3-26.5h-43.6V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.215762a8c2fe3f0dec01a673f0de15c9.svg";
export { ForwardRef as ReactComponent };